module.exports = __webpack_public_path__ + "img/collector.b2d20b34.jpg";